// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3Ox4m","footer":"ReportModalFilter_footer__2kUK6"};